// extracted by mini-css-extract-plugin
export default {"override":"page-header_override__8IKdu"};